import type { HttpClientOptions } from '@repo/lib-http-client';
import { HttpClient } from '@repo/lib-http-client';
import type {
  AuthReqBodyDto,
  AuthResBody,
  CreatePaymentIntentResBody,
} from '@repo/schema-api-customer-hub';
import { authResBodySchema, createPaymentIntentResBodySchema } from '@repo/schema-api-customer-hub';

interface CustomerHubApiClientConfig {
  baseUrl: string;
  token?: string;
}

export class CustomerHubApiClient {
  private readonly httpClient: HttpClient;

  public constructor({ baseUrl, token }: CustomerHubApiClientConfig) {
    const headers: HttpClientOptions['headers'] = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    this.httpClient = new HttpClient({
      baseURL: baseUrl,
      timeout: 0,
      headers,
    });
  }

  public setAuthorization(token: string): void {
    this.httpClient.setAuthorization(token);
  }

  public async authenticate(data: AuthReqBodyDto): Promise<AuthResBody['data']> {
    const response = await this.httpClient.post('/auth', {
      data,
      schema: authResBodySchema,
    });

    return response.data;
  }

  public async createPaymentIntent(): Promise<CreatePaymentIntentResBody['data']> {
    const response = await this.httpClient.post('/payments/intent', {
      schema: createPaymentIntentResBodySchema,
    });

    return response.data;
  }
}

export const customerHubApiClient = new CustomerHubApiClient({
  baseUrl: import.meta.env.VITE_API_BASE_URL,
});
